import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";

export function Index() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/workflow", replace: true });
  }, [navigate]);
  return null;
}
